/* Material-specific customer notices shared by the kit builder and product forms. */
(function () {
  'use strict';
  const normalize = value => String(value || '').trim().toLowerCase();
  const processing = 'Made to order — ships in 4–7 days. Shipping time is additional.';
  const advanced = 'Advanced Vinyl - Please watch install guide';
  function isPrinted(material) {
    return !!material && ['print', 'printed'].includes(normalize(material.visual_character));
  }
  function apply(material, vinylInput, processingInput, notices) {
    const printed = isPrinted(material);
    for (const [input, value] of [
      [vinylInput, material && normalize(material.vinyl_group) === 'advanced' ? advanced : ''],
      [processingInput, printed ? processing : '']
    ]) {
      if (!input) continue;
      input.value = value;
      input.disabled = !value;
    }
    for (const notice of notices || []) {
      if (!notice) continue;
      notice.hidden = !printed;
      const message = notice.id === 'wizard-processing-summary'
        ? 'Made to order · Ships in 4–7 days.\nShipping time is additional.'
        : processing + ' Expedited shipping does not shorten production time.';
      notice.textContent = printed ? message : '';
    }
  }
  window.M2MaterialNotices = { isPrinted, apply };
  // Resolve each selected variant's material, rather than retaining an initial SKU guess.
  class MaterialNotices extends HTMLElement {
    connectedCallback() {
      if (this.onVariantChange) return;
      this.form = this.closest('form');
      if (!this.form) return;
      const data = JSON.parse(this.querySelector('[data-notice-materials]').textContent);
      const update = variant => {
        const label = normalize(variant && variant['option' + data.position]);
        const material = data.materials.find(item => normalize(item.label) === label);
        apply(material, this.querySelector('[data-vinyl-notice]'),
          this.querySelector('[data-processing-notice]'), this.querySelectorAll('[data-lead-time]'));
      };
      this.onVariantChange = event => update(event.detail.variant);
      this.form.addEventListener('variant:changed', this.onVariantChange);
      update(data.variant);
    }
    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('variant:changed', this.onVariantChange);
      this.onVariantChange = null;
    }
  }
  if (!customElements.get('m2-material-notices')) customElements.define('m2-material-notices', MaterialNotices);
})();
